import React from "react";
import { motion } from "framer-motion";

export default function PersonajeSection() {
  return (
    <section
      id="personaje"
      className="section-dark relative py-28 md:py-44 overflow-hidden"
      data-testid="personaje-section"
    >
      {/* Atmosphere */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="bg-grid absolute inset-0 opacity-50" />
        <div className="lighthouse-beam" style={{ width: 780, height: 780, top: "-20%", left: "-8%" }} />
        <div
          className="orb orb-gold orb-drift-2"
          style={{ width: 420, height: 420, bottom: "-6%", right: "0%", opacity: 0.5 }}
        />
      </div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="max-w-4xl"
        >
          <p className="overline mb-8">◇ El personaje</p>
          <h2 className="font-serif font-normal text-5xl sm:text-6xl lg:text-7xl text-[#F2EFEA] leading-[1.05] tracking-[-0.01em]">
            No es tu <span className="text-[#C7AA78] italic">verdadera identidad</span>.
            <br />
            Es un personaje que aprendiste
            <br />a interpretar.
          </h2>
          <div className="gold-divider mt-10" />
        </motion.div>

        <div className="mt-16 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-7 space-y-8"
          >
            <p className="text-[#AEB4BC] text-lg md:text-xl leading-[1.7] font-light font-sans">
              Un día, hace mucho, encontraste una forma de estar en el mundo que funcionaba.
              Encajaba. Te protegía. Te hacía querido. Te hacía sentir seguro.
            </p>
            <p className="text-[#AEB4BC] text-lg md:text-xl leading-[1.7] font-light font-sans">
              Y ese día empezaste a interpretarla, a repetirla, a perfeccionarla.
              <br />
              Hasta que un día se te olvidó que era un papel.
            </p>
            <p className="font-serif italic text-[#F2EFEA] text-2xl md:text-3xl leading-[1.35] tracking-[-0.005em]">
              El personaje que un día te protegió es el mismo que hoy te está frenando.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.3 }}
            className="lg:col-span-5"
          >
            <div className="paper p-8 md:p-10 relative">
              <div className="absolute top-0 left-0 h-1 w-16 bg-[#C7AA78]" />
              <p className="text-[10px] tracking-[0.28em] uppercase text-[#C7AA78] font-medium font-sans mb-6">
                La evolución
              </p>
              <div className="space-y-4 font-sans">
                {[
                  ["01", "Piloto automático"],
                  ["02", "Patrón"],
                  ["03", "Personaje"],
                  ["04", "Conciencia"],
                  ["05", "Elección"],
                  ["06", "Identidad"],
                ].map(([n, label], i, arr) => {
                  const isCurrent = i === 2;
                  const isFuture = i > 2;
                  return (
                    <div
                      key={n}
                      className={`flex items-center gap-4 py-3 border-b border-[#F2EFEA]/8 last:border-b-0 ${
                        isFuture ? "opacity-60" : ""
                      }`}
                    >
                      <span
                        className={`font-serif italic text-sm w-8 ${
                          isCurrent ? "text-[#C7AA78]" : "text-[#7A828C]"
                        }`}
                      >
                        {n}
                      </span>
                      <span
                        className={`text-base leading-none ${
                          isCurrent
                            ? "font-serif italic text-[#F2EFEA] text-lg"
                            : "text-[#AEB4BC] font-light"
                        }`}
                      >
                        {label}
                      </span>
                      {isCurrent && (
                        <span className="ml-auto text-[10px] tracking-[0.20em] uppercase text-[#C7AA78] font-medium">
                          Aquí estás
                        </span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
